/* # =================================================================
# ページ内リンクスクロール遷移
# ================================================================= */
export default function pageScroll() {
	function isHashLinkWithoutURL(anchorHref) {
		let url = new URL(anchorHref, window.location.origin);
		return (
			url.hash.startsWith('#') && url.pathname === window.location.pathname && url.hostname === window.location.hostname
		);
	}

	document.querySelectorAll('a').forEach((anchor) => {
		anchor.addEventListener('click', function (e) {
			if (isHashLinkWithoutURL(anchor.href)) {
				e.preventDefault();

				document.querySelector(this.hash).scrollIntoView({
					behavior: 'smooth'
				});
			}
		});
	});
}
